export type LineChartSeriesKey = 'producer' | 'coproducer' | 'affiliate';

export const SERIES_TEXT_COLOR_CLASS: Record<LineChartSeriesKey, string> = {
  producer: 'text-(--uizz-antd-color-warning)',
  coproducer: 'text-(--uizz-antd-color-warning-active)',
  affiliate: 'text-(--uizz-antd-color-primary)'
};

export const SERIES_BG_COLOR_CLASS: Record<LineChartSeriesKey, string> = {
  producer: 'bg-(--uizz-antd-color-warning)',
  coproducer: 'bg-(--uizz-antd-color-warning-active)',
  affiliate: 'bg-(--uizz-antd-color-primary)'
};
